import React, { Component } from 'react';
import { Button, Table } from 'react-bootstrap';
import ui from '../../common/services/ui';

class KindergartenAttendanceTable extends Component {

	constructor(props) {
		super(props);
	}

	renderHeaderCell(attendance, index) {
		const { lessonDate } = attendance;
		return (
			<th key={index} className='center' align='center' valign='middle'>
				{ui.customDateFormat(lessonDate, 'LL')}
			</th>
		);
	}

	renderHeader() {
		const { kindergartenAttendances: { attendances } } = this.props;
		const headerCells = attendances.map((attendance, index) => this.renderHeaderCell(attendance, index));
		return (
			<tr>
				{headerCells}
			</tr>
		);
	}

	renderButtonCell(attendance, index) {
		const { onEditPaymentDetail, t, isReadonly } = this.props;
		return (
			<td key={index} className='center' align='center' valign='middle'>
				<Button bsStyle='primary' disabled={isReadonly} onClick={() => onEditPaymentDetail(attendance)}>{t('Common_Edit')}</Button>
			</td>
		);
	}

	renderButtons() {
		const { kindergartenAttendances: { attendances } } = this.props;
		const buttonCells = attendances.map((attendance, index) => this.renderButtonCell(attendance, index));
		return (
			<tr>
				{buttonCells}
			</tr>
		);
	}

	renderPaymentDetailCell(attendance, index) {
		
		const { kindergartenPaymentDetail } = attendance;
		if (!kindergartenPaymentDetail) {
			return (<td></td>);
		}

		const { kindergartenPaymentDetails, t } = this.props;
		const { childrenCount, total } = kindergartenPaymentDetails[kindergartenPaymentDetail];
		const childrenTxt = `${t('KindergartenAttendance_ChildrenCount')}: ${childrenCount ? childrenCount : 0}`;
		const totalTxt = `${t('KindergartenAttendance_Total')}: ${total ? total : 0}`;
		return (
			<td key={index} className='center' align='center' valign='middle'>
				{childrenTxt}
				<br />
				{totalTxt}
			</td>
		);
	}

	renderPaymentDetails() {
		const { kindergartenAttendances: { attendances } } = this.props;
		const paymentDetailsCells = attendances.map((attendance, index) => this.renderPaymentDetailCell(attendance, index));
		return (
			<tr>
				{paymentDetailsCells}
			</tr>
		);
	}

	render() {
		const { kindergartenAttendances } = this.props;

		if (kindergartenAttendances) {
			const header = this.renderHeader();
			const buttons = this.renderButtons();
			const paymentDetails = this.renderPaymentDetails();
			return (
				<Table bordered striped hover>
					<thead>
						{header}
					</thead>
					<tbody>
						{buttons}
						{paymentDetails}
					</tbody>
				</Table>
			);
		}

		return <div />
	}

}

export default KindergartenAttendanceTable;